import {emotionStyled} from '@packages/utilities/styled';
import {tokens} from '../../themes';
import {HStack} from '../Stack';

export const BadgeView = emotionStyled(HStack)(
  {
    borderRadius: '$1',
    display: 'inline-flex',
    width: 'fit-content',
    gap: '$1',
  },
  {
    componentName: 'Badge',
    variants: {
      colorVariant: {
        default: {
          color: '$textSecondary',
          background: '$grayTransparent',
          '& [data-wf-icon="WebflowIcon"]': {
            color: tokens.colors.blueText,
          },
        },
        primary: {
          color: '$blueText',
          background: '$blueTransparent',
        },
        green: {
          color: '$greenText',
          background: '$greenTransparent',
        },
        orange: {
          color: '$orangeText',
          background: '$orangeTransparent',
        },
        purple: {
          color: '$purpleText',
          background: '$purpleTransparent',
        },
        pink: {
          color: '$pinkText',
          background: '$pinkTransparent',
        },
        red: {
          color: '$redText',
          background: '$redTransparent',
        },
        yellow: {
          color: '$yellowText',
          background: '$yellowTransparent',
        },
      },
      density: {
        comfortable: {},
        compact: {},
      },
      isRounded: {
        true: {
          borderRadius: 9999,
        },
      },
      size: {
        medium: {},
        'x-large': {},
      },
      variant: {
        default: {},
        solid: {},
      },
    },
    compoundVariants: [
      {
        conditions: {
          colorVariant: 'default',
          variant: 'solid',
        },
        css: {
          color: '$black',
          background: '$uiBadgeBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'primary',
          variant: 'solid',
        },
        css: {
          color: '$white',
          background: '$blueBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'green',
          variant: 'solid',
        },
        css: {
          color: '$white',
          background: '$greenBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'orange',
          variant: 'solid',
        },
        css: {
          color: '$white',
          background: '$orangeBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'red',
          variant: 'solid',
        },
        css: {
          color: '$white',
          background: '$redBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'purple',
          variant: 'solid',
        },
        css: {
          color: '$white',
          background: '$purpleBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'pink',
          variant: 'solid',
        },
        css: {
          color: '$white',
          background: '$pinkBackground',
        },
      },
      {
        conditions: {
          colorVariant: 'yellow',
          variant: 'solid',
        },
        css: {
          color: '$black',
          background: '$yellowBackground',
        },
      },
      {
        conditions: {
          size: 'medium',
          density: 'compact',
        },
        css: {
          padding: '$0 $0.5',
        },
      },
      {
        conditions: {
          size: 'medium',
          density: 'compact',
          isRounded: true,
        },
        css: {
          padding: '$0 $1',
        },
      },
      {
        conditions: {
          size: 'medium',
          density: 'comfortable',
        },
        css: {
          padding: '$1 $2',
        },
      },
      {
        conditions: {
          size: 'x-large',
          density: 'compact',
        },
        css: {
          padding: '$0.5 $1',
        },
      },
      {
        conditions: {
          size: 'x-large',
          density: 'compact',
          isRounded: true,
        },
        css: {
          padding: '$0.5 $2',
        },
      },
      {
        conditions: {
          size: 'x-large',
          density: 'comfortable',
        },
        css: {
          padding: '$2 $3',
        },
      },
    ],
    defaultVariants: {
      colorVariant: 'default',
      isRounded: true,
      variant: 'default',
    },
  }
);
